var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 15.5C11.4424 15.5 13.625 13.3174 13.625 10.625C13.625 7.93261 11.4424 5.75 8.75 5.75C6.05761 5.75 3.875 7.93261 3.875 10.625C3.875 13.3174 6.05761 15.5 8.75 15.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0698 5.93076C15.7403 5.74184 16.4436 5.6988 17.1321 5.80454C17.8207 5.91029 18.4786 6.16236 19.0615 6.54377C19.6444 6.92519 20.1389 7.42709 20.5115 8.01568C20.8841 8.60427 21.1263 9.26588 21.2217 9.95594C21.3171 10.646 21.2635 11.3485 21.0645 12.0161C20.8655 12.6837 20.5258 13.3009 20.0682 13.8262C19.6107 14.3514 19.0458 14.7726 18.4118 15.0611C17.7777 15.3497 17.0892 15.4991 16.3926 15.4992",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99951 19.0059C2.76089 17.9229 3.77166 17.039 4.9465 16.4288C6.12133 15.8186 7.42574 15.5001 8.74959 15.5C10.0734 15.4999 11.3779 15.8184 12.5528 16.4285C13.7276 17.0386 14.7385 17.9225 15.4999 19.0054",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3928 15.5C17.7168 15.499 19.0215 15.8171 20.1965 16.4273C21.3715 17.0375 22.3821 17.9218 23.1429 19.0054",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.35af5a30.svg";
export { ForwardRef as ReactComponent };